import "./styles.scss";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { withRouter, useParams } from "react-router-dom";
import _ from "underscore";
import { AiOutlineSearch, AiOutlineClose } from "react-icons/ai";
import { Button, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsFilter } from "react-icons/bs";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { useHistory } from "react-router-dom";
import ModalDialog from "containers/PeopleCraft/Modals/ModalDialog";
import {
  getTeams,
  getAttendanceList,
  saveAttendanceList,
  finishAttendanceList,
  uploadAttendanceListApi,
  saveAttendanceListPath,
} from "../../../../services/NexiDigitalAPI";
import Loading from "../../../../components/Loading";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@material-ui/icons/Close";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaArrowAltCircleDown } from "react-icons/fa";
import { FaFile } from "react-icons/fa";
import useListBlenderPDF from "./Hooks/useListBlenderPDF";
import { useToast } from "hooks/useToast";

const AttendanceList = () => {
  const history = useHistory();
  const isMountedRef = useRef(null);
  const { success } = useToast();

  const [modalDilogParamiters, setModalDilogParamiters] = useState({});
  const [showModalDialog, setShowModalDialog] = useState(false);
  const [showModalSignedList, setShowModalSignedList] = useState(false);

  const [loadindData, setLoadindData] = useState(true);

  const [pageLimit, setPageLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const currentTablePage = useRef(1);

  const [meetings, setMeetings] = useState([]);
  const [currentMeeting, setCurrentMeeting] = useState({});
  const [lista, setLista] = useState([]);

  const attendanceListEnabled = useRef(null);
  const [turmaTitle, setTurmaTitle] = useState("");
  const { idTeam, pageTitle } = useParams();
  const idMeeting = useRef(null);
  const inputSearch = useRef(null);
  const inputSearchRef = useRef(null);
  const [uploadingData, setUploadingData] = useState(false);

  const [attendanceStatusMap, setAttendanceStatusMap] = useState({});
  const [attendanceRawMap, setAttendanceRawMap] = useState({});

  useEffect(() => {
    isMountedRef.current = true;
    getAvailableTeamMeetings();
    return () => (isMountedRef.current = false);
  }, []);

  const getAvailableTeamMeetings = async () => {
    setAttendanceStatusMap({});
    setLoadindData(true);
    getTeams({ idTeam })
      .then((response) => {
        setMeetings(response.data.meetings);
        setTurmaTitle(response.data.name);
        setLoadindData(false);
      })
      .catch((err) => {
        console.log("Error", err);
        setLoadindData(false);
      });
  };

  const getAvailableData = async (newOffset, limit, resetStates = false) => {
    setLoadindData(true);

    if (resetStates) {
      setAttendanceStatusMap((prev) => ({
        ...prev,
        [idMeeting.current]: {
          ...(prev[idMeeting.current] || {}),
          selectAll: false,
          selectAllAttendance: false,
          selectAllNonAttendance: false,
          userStatus: { ...(prev[idMeeting.current]?.userStatus || {}) },
        },
      }));
    }

    if (newOffset === 0) {
      currentTablePage.current = 1;
    }

    const haveNewOffset = newOffset || newOffset === 0;
    if (haveNewOffset) {
      setOffset(newOffset);
    }

    const listParameters = {
      searchString: inputSearch.current ? inputSearch.current : null,
      offset: haveNewOffset ? newOffset : offset,
      limit: limit ? limit : pageLimit,
      idTeam: idTeam,
      idMeeting: idMeeting.current,
    };

    const availableData = await getAttendanceList(listParameters).catch((err) => {
      console.log("error", err);
    });

    if (availableData) {
      const totalUsersRecord = availableData.totalRecords;

      const usersList = availableData.attendanceList.map((obj) => {
        if (obj) {
          if (obj.hasOwnProperty("idAttendanceList") && obj.idAttendanceList === null) {
            delete obj.idAttendanceList;
          }
          const meetingState = attendanceStatusMap[idMeeting.current] || {};
          const storedStatus = meetingState.userStatus ? meetingState.userStatus[obj.idUser] : undefined;
          return {
            ...obj,
            present: storedStatus !== undefined ? storedStatus : obj.present,
          };
        }
        return obj;
      });

      setAttendanceRawMap((prev) => ({
        ...prev,
        [idMeeting.current]: {
          ...(prev[idMeeting.current] || {}),
          ...Object.fromEntries(usersList.map((user) => [user.idUser, user])),
        },
      }));

      const meetingState = attendanceStatusMap[idMeeting.current] || {};
      if (meetingState.selectAllNonAttendance && meetingState.selectAll && !resetStates) {
        const newListNonAttendance = usersList.map((obj) => (obj ? { ...obj, present: 0 } : obj));

        const updatedUserStatus = {
          ...(meetingState.userStatus || {}),
          ...Object.fromEntries(newListNonAttendance.map((u) => [u.idUser, 0])),
        };

        setAttendanceStatusMap((prev) => ({
          ...prev,
          [idMeeting.current]: {
            ...(prev[idMeeting.current] || {}),
            userStatus: updatedUserStatus,
          },
        }));

        setLista(_.sortBy(newListNonAttendance, "name"));
      } else if (meetingState.selectAllAttendance && meetingState.selectAll && !resetStates) {
        const newListAttendance = usersList.map((obj) => (obj ? { ...obj, present: 1 } : obj));
        const updatedUserStatus = {
          ...(meetingState.userStatus || {}),
          ...Object.fromEntries(newListAttendance.map((u) => [u.idUser, 1])),
        };

        setAttendanceStatusMap((prev) => ({
          ...prev,
          [idMeeting.current]: {
            ...(prev[idMeeting.current] || {}),
            userStatus: updatedUserStatus,
          },
        }));

        setLista(_.sortBy(newListAttendance, "name"));
      } else {
        setLista(_.sortBy(usersList, "name"));
      }

      setTotalRecords(totalUsersRecord);
      setLoadindData(false);
    }
  };

  const updateAttendanceStatus = (meetingId, userId, presentValue) => {
    setAttendanceStatusMap((prev) => {
      const meeting = prev[meetingId] || {};
      return {
        ...prev,
        [meetingId]: {
          ...meeting,
          selectAll: false,
          selectAllAttendance: false,
          selectAllNonAttendance: false,
          userStatus: {
            ...(meeting.userStatus || {}),
            [userId]: presentValue,
          },
        },
      };
    });

    setLista((prevLista) =>
      prevLista.map((obj) => (obj.idUser === userId ? { ...obj, present: presentValue } : obj))
    );
  };

  const onChangePage = (page) => {
    currentTablePage.current = page;
    const newOffset = (page - 1) * pageLimit;
    const meetingState = attendanceStatusMap[idMeeting.current] || {};

    const reset = meetingState.selectAll ? false : true;
    getAvailableData(newOffset, null, reset);
  };

  const onChangeTable = (a, b, c, d) => {
    console.log(a, b, c, d);
  };

  const onChangeRowsPerPage = (limit, page) => {
    setPageLimit(limit);
    const newOffset = (page - 1) * limit;
    getAvailableData(newOffset, limit);
  };

  const columns = [
    {
      name: "Nome",
      sortable: true,
      selector: "name",
      center: false,
      wrap: true,
      width: "30%",
      style: { textAlign: "left" },
      cell: (user) => (
        <div>
          <p>{user.name}</p>
        </div>
      ),
    },
    {
      name: (
        <div className="collumHeader">
          <p>Presente</p>
          <div className="selectAll">
            <Form.Check
              name="group2"
              type={"checkbox"}
              checked={(attendanceStatusMap[idMeeting.current] || {}).selectAllAttendance || false}
              onChange={async (e) => {
                const checked = e.target.checked;

                const updatedUserStatus = {
                  ...((attendanceStatusMap[idMeeting.current] && attendanceStatusMap[idMeeting.current].userStatus) || {}),
                  ...Object.fromEntries(
                    lista.map((obj) => [obj.idUser, checked ? 1 : 0])
                  ),
                };

                setAttendanceStatusMap((prev) => ({
                  ...prev,
                  [idMeeting.current]: {
                    ...(prev[idMeeting.current] || {}),
                    selectAllAttendance: checked,
                    selectAllNonAttendance: false,
                    selectAll: false,
                    userStatus: updatedUserStatus,
                  },
                }));

                if (checked) {
                  const newList = lista.map((obj) => (obj ? { ...obj, present: 1 } : obj));
                  setLista(newList);
                } else {
                  getAvailableData(null, pageLimit, true);
                }
              }}
            />
          </div>
        </div>
      ),
      selector: "checkbox",
      sortable: false,
      center: false,
      wrap: true,
      width: "150px",
      style: { textAlign: "left" },
      cell: (user) => (
        <div className="ml-1">
          <Form.Check
            name="group1"
            type={"checkbox"}
            checked={user.present == 1}
            onChange={() => updateAttendanceStatus(user.idMeeting, user.idUser, 1)}
          />
        </div>
      ),
    },
    {
      name: (
        <div className="collumHeader">
          <p>Ausente</p>
          <div className="selectAll">
            <Form.Check
              name="group2"
              type={"checkbox"}
              checked={(attendanceStatusMap[idMeeting.current] || {}).selectAllNonAttendance || false}
              onChange={async (e) => {
                const checked = e.target.checked;
                const updatedUserStatus = {
                  ...((attendanceStatusMap[idMeeting.current] && attendanceStatusMap[idMeeting.current].userStatus) || {}),
                  ...Object.fromEntries(
                    lista.map((obj) => [obj.idUser, checked ? 0 : 1])
                  ),
                };

                setAttendanceStatusMap((prev) => ({
                  ...prev,
                  [idMeeting.current]: {
                    ...(prev[idMeeting.current] || {}),
                    selectAllNonAttendance: checked,
                    selectAllAttendance: false,
                    selectAll: false,
                    userStatus: updatedUserStatus,
                  },
                }));

                if (checked) {
                  const newList = lista.map((obj) => (obj ? { ...obj, present: 0 } : obj));
                  setLista(newList);
                } else {
                  getAvailableData(null, pageLimit, true);
                }
              }}
            />
          </div>
        </div>
      ),
      selector: "checkbox",
      sortable: false,
      center: false,
      wrap: true,
      width: "150px",
      style: { textAlign: "left" },
      cell: (user) => (
        <div className="ml-1">
          <Form.Check
            name="group3"
            type={"checkbox"}
            checked={user.present == 0}
            onChange={() => updateAttendanceStatus(user.idMeeting, user.idUser, 0)}
          />
        </div>
      ),
    },
  ];



  const saveAttendanceListFn = async (e, currentAll = false) => {
    if (e?.preventDefault) e.preventDefault();
    setLoadindData(true);

    const entries = Object.entries(attendanceStatusMap);
    let allSaveRequests = entries.map(([meetingId, meetingState]) => {
      const fullDataMap = attendanceRawMap[meetingId] || {};
      const usersMap = meetingState.userStatus || {};
      if(!Object.keys(usersMap).length) return Promise.resolve();

      const all = meetingState.selectAll || (currentAll && String(meetingId) === String(idMeeting.current));
      if (all ) {
        return saveAttendanceList(
          {
            idTeam,
            idMeeting: parseInt(meetingId),
            users: [],
          },
          meetingState.selectAllAttendance ? 1 : 0
        );
      }

      const users = Object.entries(usersMap)
        .map(([idUser, present]) => {
          const fullData = fullDataMap[idUser];
          return {
            ...(fullData || {}),
            present,
            idMeeting: parseInt(meetingId),
          };
        })
        .filter(Boolean);

      const payload = {
        idTeam: idTeam,
        idMeeting: parseInt(meetingId),
        users,
      };

      return saveAttendanceList(payload, null);
    });

    return Promise.all(allSaveRequests)
      .then(() => {
        setLoadindData(false);
        setAttendanceStatusMap({});
        success('Lista de presença salva com sucesso.');
        if (e) history.goBack();
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoadindData(false);
      });
  };

  const finishAttendanceListFn = (e) => {


    if (e) {
      if (e.hasOwnProperty("saveAttendanceListFn")) {
        e.preventDefault();
      }
    }
    setLoadindData(true);
    setModalDilogParamiters({
      text: `Você tem certeza que deseja encerrar a lista de presença? Após finalizada a lista não poderá ser editada.`,
      variantBtn: "danger",
      textBtn: "Encerrar lista de presença",
      fnc: async () => {
        await saveAttendanceListFn(null);
        const finishAttendanceListParams = {
          idTeam: idTeam,
          idMeeting: idMeeting.current,
        };

        finishAttendanceList(finishAttendanceListParams)
          .then((response) => {
            setLoadindData(false);
            history.goBack();
          })
          .catch((err) => {
            console.log("Error", err);
            setLoadindData(false);
          });
      },
    });
    setShowModalDialog(true);
  };

  const { createListBlender, preloaderListBlender } = useListBlenderPDF({
    turmaTitle,
    pageTitle,
    currentMeeting,
    idTeam,
    idMeeting: idMeeting.current,
  });

  const openSignedListModal = useCallback(() => {
    if (currentMeeting?.idMeeting) {
      setShowModalSignedList(true);
    }
  }, [currentMeeting?.idMeeting]);

  const uploadSignedList = useCallback(
    (file) => {
      setUploadingData(true);
      const selectedFile = file.files[0];
      if (selectedFile) {
        const filename = selectedFile.name.split(".");
        filename.pop();
        const data = new FormData();
        data.append("fileData", selectedFile);
        data.append("fileName", filename.join());
        data.append("idMeeting", currentMeeting?.idMeeting);
        uploadAttendanceListApi(data)
          .then(async (response) => {
            if (response.data.success) {
              await saveAttendanceListPath(
                idTeam,
                currentMeeting?.idMeeting,
                response.data.attendanceList
              );
              setCurrentMeeting((prev) => ({
                ...prev,
                signedAttendanceListPath: response.data.attendanceList,
              }));
            }
          })
          .catch((e) => {
            alert(`Não fi possível processar o arquivo '${selectedFile.name}'.`);
          })
          .finally(() => {
            setUploadingData(false);
          });
      } else {
        setUploadingData(false);
      }
    },
    [currentMeeting?.idMeeting, idTeam]
  );

  const clearInputPath = () => {
    let element = document.getElementById("upload-button-file");
    element.value = "";
  };

  const downloadSignedList = useCallback(() => {
    if (currentMeeting?.signedAttendanceListPath) {
      const { domain } = JSON.parse(localStorage.getItem("appDetails"));
      const link = document.createElement("a");
      link.href = `https://${domain}/${currentMeeting.signedAttendanceListPath}`;
      link.target = "_blank";
      link.click();
    }
  }, [currentMeeting?.signedAttendanceListPath]);

  const currentMeetingState = attendanceStatusMap[idMeeting.current] || {};

  return (
    <div className="meetingsInsertUsers">
      {(loadindData || preloaderListBlender) && <Loading className={"loadindData"} />}
      {showModalDialog && (
        <ModalDialog
          title={modalDilogParamiters.title}
          text={modalDilogParamiters.text}
          show={showModalDialog}
          setShow={setShowModalDialog}
          btnCall={{
            className: "",
            variantBtn: modalDilogParamiters.variantBtn,
            text: modalDilogParamiters.textBtn,
            alertMode: modalDilogParamiters.alertMode,
            callEvent: () => {
              if (modalDilogParamiters.fnc) {
                modalDilogParamiters.fnc();
              }
            },
          }}
          btnDenyCall={modalDilogParamiters.fncDeny}
        />
      )}
      <Modal
        className="modal-signed-list"
        size="lg"
        onHide={() => setShowModalSignedList(false)}
        show={showModalSignedList}
        centered
      >
        <Modal.Header className="modal-signed-list-header">
          <div>Lista de presença assinada</div>
          <div
            onClick={() => setShowModalSignedList(false)}
            className="modal-warning-close-container"
            style={{ margin: 15, padding: 0, backgroundColor: "#6b48ff" }}
          >
            <CloseIcon style={{ color: "white" }} className="modal-warning-close" />
          </div>
        </Modal.Header>
        <Modal.Body className="modal-signed-list-body">
          <p>
            <strong>Nome da turma:</strong> {turmaTitle}
          </p>
          <p>
            <strong>Encontro:</strong>{" "}
            {`[${new Date(currentMeeting.startDate).toLocaleDateString("pt-BR")} - ${new Date(
              currentMeeting.finishDate
            ).toLocaleDateString("pt-BR")}] ${currentMeeting.meetingType} - ${
              currentMeeting.speaker
            }`}
          </p>
          <div className="modal-signed-list-upload-container">
            <div className="file-info">
              <div>Faça upload de arquivo</div>
              <div>
                PDF, JPEG, PNG (<strong>10MB</strong> limite de tamanho)
              </div>
            </div>
            <div className="file-upload">
              <label htmlFor="upload-button-file">
                <div className="btn btn-primary">
                  <FaCloudUploadAlt /> {uploadingData ? "Uploading..." : "Carregar lista assinada"}
                  <input
                    disabled={uploadingData}
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="upload-button-file"
                    type="file"
                    hidden
                    onChange={(e) => uploadSignedList(e.target)}
                    onClick={() => clearInputPath()}
                  />
                </div>
              </label>
            </div>
          </div>
          <div className="modal-signed-list-result-container">
            {currentMeeting?.signedAttendanceListPath ? (
              <div className="result-info-file">
                <div>{currentMeeting?.signedAttendanceListPath.split("/").pop()}</div>
                <div className="btn-download" onClick={() => downloadSignedList()}>
                  <FaArrowAltCircleDown />
                </div>
              </div>
            ) : (
              <div className="result-info-empty">
                <div>
                  <FaFile />
                </div>
                <div>Não há arquivos para serem exibidos</div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
      <div className="PA-header-title-wrapper">
        <div className="PA-header-title">
          <button
            className="btnGoBack"
            onClick={() => {
              history.goBack();
            }}
          >
            <KeyboardArrowLeftIcon style={{ fontSize: 40 }} />
          </button>
          Gestão de turmas / <b>Lista de presença</b>
        </div>
      </div>
      <div className="meetingListHeader">
        <h5>
          Lista de presença {pageTitle} - {turmaTitle}
        </h5>
        <div className="filters">
          <div className="meetingChoice">
            <h6>Encontro:</h6>
            <Form.Control
              className=""
              as="select"
              value={null}
              onChange={(e) => {
                if (e.target.value === "Selecione um encontro") {
                  setCurrentMeeting({});
                  setAttendanceStatusMap({});
                  setLista([]);
                  return;
                }
                const selectedMeeting = JSON.parse(e.target.value);
                setCurrentMeeting(selectedMeeting);
                idMeeting.current = selectedMeeting.idMeeting;
                attendanceListEnabled.current = selectedMeeting.attendanceListEnabled;

                setAttendanceStatusMap((prev) => ({
                  ...prev,
                  [idMeeting.current]: {
                    ...(prev[idMeeting.current] || {}),
                    selectAll: false,
                    selectAllAttendance: false,
                    selectAllNonAttendance: false,
                    userStatus: prev[idMeeting.current]?.userStatus || {},
                  },
                }));
                getAvailableData(0, pageLimit, true);
              }}
              placeholder={`Selecione um encontro`}
            >
              <option value={null}>{"Selecione um encontro"}</option>
              {meetings ? (
                meetings.map((meeting, i) => {
                  return (
                    <option key={i} value={JSON.stringify(meeting)}>
                      {meeting.startDate
                        ? `[ ${new Date(meeting.startDate).toLocaleDateString(
                            "pt-BR"
                          )} - ${new Date(meeting.finishDate).toLocaleDateString("pt-BR")} ] ${
                            meeting.meetingType
                          } - ${meeting.speaker}`
                        : `Encontro ${i + 1}`}
                    </option>
                  );
                })
              ) : (
                <></>
              )}
            </Form.Control>
          </div>
          <div className={`filtersOptions ${lista.length === 0 ? "disabled" : ""}`}>
            <h6>Procurar aluno:</h6>
            <div className="searchInfo">
              <AiOutlineSearch />
              <Form.Control
                ref={inputSearchRef}
                onKeyDown={(input) => {
                  if (input.key === "Enter") {
                    getAvailableData(0, pageLimit, true);
                  }
                }}
                onChange={(e) => {
                  inputSearch.current = e.target.value;
                }}
                placeholder={`Procurar por nome ou e-mail`}
              />
              <button
                onClick={() => {
                  inputSearchRef.current.value = "";
                  inputSearch.current = "";
                  getAvailableData(0, pageLimit, true);
                }}
              >
                <AiOutlineClose />
              </button>
            </div>
          </div>
          <div className="btnList">
            <Button
              variant="primary"
              className={`filterUsersBtn ${lista.length === 0 ? "disabled" : ""}`}
              onClick={() => getAvailableData(0, pageLimit, true)}
            >
              <BsFilter />
              Filtrar
            </Button>
            <div>
              <Button
                variant="primary"
                className={`${lista.length === 0 ? "disabled" : ""}`}
                onClick={createListBlender}
              >
                Baixar PDF da Lista
              </Button>
              <Button
                variant="warning"
                className={`${lista.length === 0 ? "disabled" : ""}`}
                onClick={openSignedListModal}
              >
                {currentMeeting?.signedAttendanceListPath
                  ? "Visualizar lista assinada"
                  : "Anexar lista assinada"}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="listBody">
        {lista.length > 0 && (
          <>
            <div className="selectAll">
              {((currentMeetingState.selectAllAttendance === true) ||
                (currentMeetingState.selectAllNonAttendance === true)) && (
                <p className="selectAllMsg">
                  {" "}
                  <b>{currentMeetingState.selectAll ? totalRecords : lista.length} alunos</b> foram marcados como{" "}
                  {currentMeetingState.selectAllAttendance ? "presentes" : "ausentes"}.
                  {currentMeetingState.selectAll === false ? (
                    <spam
                      className="btnSelectAll"
                      onClick={(e) => {
                        setModalDilogParamiters({
                          text: `Você confirma as informações registradas na lista de presença?
                                Clique em Salvar alterações para confirmar.`,
                          variantBtn: "success",
                          alertMode: false,
                          fnc: () => {
                            setAttendanceStatusMap((prev) => ({
                              ...prev,
                              [idMeeting.current]: {
                                ...(prev[idMeeting.current] || {}),
                                selectAll: true,
                              },
                            }));
                            saveAttendanceListFn(null, true);
                          },
                          fncDeny: () => {
                            setAttendanceStatusMap((prev) => ({
                              ...prev,
                              [idMeeting.current]: {
                                ...(prev[idMeeting.current] || {}),
                                selectAll: false,
                                selectAllAttendance: false,
                                selectAllNonAttendance: false,
                              },
                            }));
                          },
                          textBtn: "Salvar alterações",
                        });
                        setShowModalDialog(true);
                      }}
                    >
                      Marcar todos os {totalRecords} alunos do encontro como{" "}
                      {currentMeetingState.selectAllAttendance ? "presentes" : "ausentes"}.
                    </spam>
                  ) : (
                    <spam
                      className="btnSelectAll"
                      onClick={(e) => {
                        setAttendanceStatusMap((prev) => ({
                          ...prev,
                          [idMeeting.current]: {
                            ...(prev[idMeeting.current] || {}),
                            selectAll: false,
                            selectAllAttendance: false,
                            selectAllNonAttendance: false,
                          },
                        }));
                        getAvailableData(null, pageLimit, true);
                      }}
                    >
                      Desmarcar todos os {totalRecords} alunos do encontro como{" "}
                      {currentMeetingState.selectAllAttendance ? "presentes" : "ausentes"}.
                    </spam>
                  )}
                </p>
              )}
            </div>
            {lista.length > 0 && attendanceListEnabled.current === 0 && (
              <div className="listCompleted">
                <h6>*Atenção! Esta lista de presença já foi encerrada e não pode ser editada.</h6>
              </div>
            )}
            <div className="meetingListTableContainer">
              <DataTable
                disabled={attendanceListEnabled.current === 0}
                columns={columns}
                data={lista}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                paginationTotalRows={totalRecords}
                paginationComponentOptions={{
                  rowsPerPageText: "Conteúdos por página",
                  rangeSeparatorText: "de",
                }}
                responsive={true}
                paginationDefaultPage={currentTablePage.current}
                paginationResetDefaultPage={true}
                paginationRowsPerPageOptions={[10, 30, 50, 70, 100]}
                paginationServer
                noHeader
                fixedHeader
                pagination
              />
            </div>
          </>
        )}
      </div>
      {lista.length > 0 && attendanceListEnabled.current === 1 && (
        <div className="userListFooter">
          <p className="listFinishInfo">
            Atenção! Você terá até 10 dias corridos após a data fim da turma para finalizar as
            listas de presença dos encontros. Após essa data a lista será finalizada
            automaticamente.
          </p>
          <button
            className="button-peop saveBtn"
            onClick={(e) => {
              saveAttendanceListFn(e);
            }}
          >
            Salvar e fechar
          </button>
          <button
            className="button-peop button-yellow finishBtn"
            onClick={(e) => {
              finishAttendanceListFn(e);
            }}
          >
            Encerrar lista de presença
          </button>
        </div>
      )}
    </div>
  );
};

export default withRouter(AttendanceList);
